export default __webpack_public_path__ + "static/media/MAINFT.f902a529.mp4";